import { Banknote, CreditCard, Wallet } from "lucide-react";

export default function PaymentPill({ method, selected, onSelect, labelOverride, descriptionOverride }) {
  const map = {
    pickup:        { title: "Pay on pickup",     hint: "Cash or card at office", icon: <Wallet size={14} /> },
    card:          { title: "Card online",       hint: "Credit / debit card",    icon: <CreditCard size={14} /> },
    bank_transfer: { title: "Bank transfer",     hint: "IBAN / wire",            icon: <Banknote size={14} /> },
    paypal:        { title: "PayPal",            hint: "Pay with your PayPal account", icon: <Wallet size={14} /> },
    viva:          { title: "Card Online via Viva Wallet", hint: "Secure Viva Smart Checkout", icon: <CreditCard size={14} /> },
  };
  const meta = map[method] || { title: method, hint: "", icon: <Wallet size={14} /> };
  const title = labelOverride || meta.title;
  const hint = descriptionOverride || meta.hint;
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex items-center gap-2 px-3 py-2.5 rounded border text-left transition-colors ${
        selected ? "border-black bg-neutral-900 text-white" : "border-black/10 hover:border-black/30"
      }`}
      data-testid={`pb-pay-${method}`}
      aria-pressed={selected}
    >
      {meta.icon}
      <div className="flex-1">
        <p className="text-sm font-medium">{title}</p>
        <p className={`text-[11px] ${selected ? "text-white/70" : "text-neutral-500"}`}>{hint}</p>
      </div>
    </button>
  );
}
